import { gql } from '@apollo/client';
import { SendGenericRetargetingDataInput, SendGenericRetargetingDataPayload } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';

const SEND_GENERIC_RETARGETING_DATA = gql`
  mutation sendGenericRetargetingData($input: sendGenericRetargetingDataInput!) {
    sendGenericRetargetingData(input: $input) {
      success
    }
  }
`;

export async function sendGenericRetargetingDataAsync(
  data: SendGenericRetargetingDataInput,
): Promise<SendGenericRetargetingDataPayload> {
  const { selectedPlan, planPrice, address, viewedPlans, customerRelationshipId, recordType } = data;
  const response = await client.mutate({
    mutation: SEND_GENERIC_RETARGETING_DATA,
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        selectedPlan,
        planPrice,
        address,
        viewedPlans,
        customerRelationshipId,
        recordType,
      },
    },
  });
  
  return {
    success: response.data.sendGenericRetargetingData.success,
  };
}
